<template>
  <vue-scroll style="height:100%">
    <div class="heading">Timeline</div>
    <div class="card" v-for="(feed, idx) in timelineData" :key="idx">
      <div class="avator">
        <el-button
          v-if="feed.owner_user.firstname"
          :class="[avatarColorOptions[idx % 10]]"
          class="display-inline-block uppercase avatar-circle cursor-pointer"
          type="text"
          circle
          >{{ `${feed.owner_user.firstname[0]} ${feed.owner_user.lastname[0]}` }}</el-button
        >
        <span v-else class="avatar-circle"> <i class="avatar-circle unassigned material-icons" circle>block</i> </span>
      </div>
      <div class="content">
        <div class="time">{{ $moment(feed.updated_on).fromNow() }}</div>
        <div class="metadata">
          <div class="assignee">
            Assigned from : {{ feed.assigned_from_user.firstname }} {{ feed.assigned_from_user.lastname }}
          </div>
          <div>Comments : {{ feed.comments ? feed.comments : 'None' }}</div>
        </div>
      </div>
    </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'ActivitiesTimelineFeed',
  props: {
    timelineData: {
      default () {
        return {}
      },
      type: [Array, Object]
    }
  },
  data () {
    return {
      avatarColorOptions: [
        'shamrock-200',
        'amaranth-300',
        'candlelight-700',
        'denim-300',
        'tuna-600',
        'shamrock-500',
        'amaranth-700',
        'candlelight-900',
        'denim-700',
        'tuna-800'
      ]
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/colors.css';

.timeline {
  color: var(--text-submenu-color);
  line-height: 1.4;
  cursor: default;
  font-family: inherit;
}

.heading {
  background: #e9e9e9;
  padding: 10px 0px 5px 25px;
  margin: 24px 0px 0px 0px;
  border: 2px solid #d5d5d5;
  border-left: none;
  height: 3.5%;
  color: black;
}

.card {
  border-bottom: 1px solid #d5d5d5;
  display: flex;
  padding: 24px 0px 24px 0px;
}

.avator {
  width: 13%;
  padding: 32px 0px 0px 25px;
}

.content {
  width: 80%;
}

.avatar-circle {
  color: white;
  letter-spacing: -1px;
  font-size: 13px;
  height: 32px;
  width: 32px;
  padding: 0px;
  position: relative;

  &.unassigned {
    font-size: 32px;
    color: var(--aluminum-400);
    line-height: 32px;
    vertical-align: middle;
  }

  &.active {
    border: 2px solid white;
  }
  &.active::after {
    content: '';
    border: 2px solid #197de6;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    position: absolute;
    left: -4px;
    top: -4px;
  }
}

.display-inline-block {
  display: inline-block;
}

.uppercase {
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.time {
  margin: 0px 0px 16px 0px;
  color: gray;
}

.metadata {
  font-weight: 500;
}

.assignee {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/feed/ActivitiesTimelineFeed.vue